import * as jose from "jose";
import isEqual from "lodash.isequal";
import axios from "axios";
import { aresPublicKey, aresPrivateKey } from "../../keys";
import { db } from "../../db";

export const types = {
  USER_LOGIN_REQUEST: "USER_LOGIN_REQUEST",
  USER_LOGIN_ERROR: "USER_LOGIN_ERROR",
  USER_LOGGED: "USER_LOGGED",
  USER_SELECT_TENANT: "USER_SELECT_TENANT",
  USER_SELECT_BRANCH: "USER_SELECT_BRANCH",
  USER_CREATE_BRANCH: "USER_CREATE_BRANCH",
  USER_DELETE_BRANCH: "USER_DELETE_BRANCH",
  USER_LOGOUT: "USER_LOGOUT",
  USER_LOGGED_STATUS: "USER_LOGGED_STATUS",
  USER_LOGGED_USERS: "USER_LOGGED_USERS"
};

const apiEndp = process.env.REACT_APP_API_ENDPOINT;

export function userLoginRequest(username, password, cb, errorCb) {
  return async (dispatch, getState) => {
    dispatch({
      type: types.USER_LOGIN_REQUEST
    });
    const alg = "RS256";
    const iss = "ares-control-center";
    const iat = Math.floor(Date.now() / 1000);
    const exp = iat + 60;
    const data = { username, password };

    const publicKey = await jose.importSPKI(aresPublicKey, alg);
    const privateKey = await jose.importPKCS8(aresPrivateKey, alg);

    const loginToken = await new jose.SignJWT(data)
      .setProtectedHeader({ alg })
      .setIssuedAt(iat)
      .setIssuer(iss)
      .setExpirationTime(exp)
      .sign(privateKey);

    axios
      .get(`${apiEndp}/login`, { headers: { loginToken } })
      .then(async ({ data }) => {
        if (data) {
          const { payload } = await jose.jwtVerify(data, publicKey);

          dispatch(userLogged({ ...payload, id_token: payload.token }));
          cb(data);
        } else dispatch({ type: types.USER_LOGIN_ERROR });
      })
      .catch((e) => {
        console.log(e);
        errorCb && errorCb(e.message);
      });
  };
}

export function setLoggedStatus(status) {
  return async (dispatch, getState) => {
    const state = getState();
    const loggedStatus = state.user.loggedStatus;

    if (!isEqual(status, loggedStatus))
      dispatch({ type: types.USER_LOGGED_STATUS, payload: status });
  };
}

export function setLoggedUsers(status) {
  return async (dispatch, getState) => {
    const state = getState();
    const loggedUsers = state.user.loggedUsers;

    if (!isEqual(status, loggedUsers))
      dispatch({ type: types.USER_LOGGED_USERS, payload: status });
  };
}

export function userLogged(user) {
  return {
    type: types.USER_LOGGED,
    payload: user
  };
}

export function userLogOut(w) {
  return (dispatch, getState) => {
    window.document.title = window.document.title.split(" : ")[0];
    dispatch({ type: types.USER_LOGOUT });
  };
}

export function userSelectTenant(tenant, branch, user) {
  return (dispatch, getState) => {
    dispatch({
      type: types.USER_SELECT_TENANT,
      payload: { tenant, branch }
    });
  };
}

export function userSelectBranch(branch) {
  db.setBranch(branch);
  return (dispatch, getState) => {
    dispatch({
      type: types.USER_SELECT_BRANCH,
      payload: branch
    });
  };
}

export function userCreateBranch(branch) {
  db.setBranch(branch);
  return (dispatch, getState) => {
    dispatch({
      type: types.USER_CREATE_BRANCH,
      payload: branch
    });
  };
}

export function userDeleteBranch(branch) {
  db.setBranch(branch);
  return (dispatch, getState) => {
    dispatch({
      type: types.USER_DELETE_BRANCH,
      payload: branch
    });
  };
}
